import { useCallback, useEffect, useState } from "react";
import { listAdultTransfers } from "../api/adultTransfersApi";

export default function useAdultTransfers(adultId) {
  const [transfers, setTransfers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refetch = useCallback(async () => {
    if (!adultId) {
      setTransfers([]);
      return [];
    }

    setLoading(true);
    setError(null);
    try {
      const data = await listAdultTransfers(adultId);
      setTransfers(Array.isArray(data) ? data : []);
      return data;
    } catch (e) {
      console.error("[useAdultTransfers] fetch failed:", e);
      setError(e);
      setTransfers([]);
      return [];
    } finally {
      setLoading(false);
    }
  }, [adultId]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { transfers, loading, error, refetch, setTransfers };
}
